import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui";
import { BitacoraTab } from "../bitacora/BitacoraTab";

/** Bitácora filtrada al flujo abierto en el diseñador. */
export function BitacoraFlujoDialog({ flujoId, abierto, onCerrar }: { flujoId: string; abierto: boolean; onCerrar: () => void }) {
  return (
    <Dialog open={abierto} onOpenChange={(o) => (!o ? onCerrar() : undefined)}>
      <DialogContent className="max-h-[90vh] max-w-6xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Bitácora del flujo</DialogTitle>
        </DialogHeader>
        {abierto ? <BitacoraTab flujoId={flujoId} /> : null}
      </DialogContent>
    </Dialog>
  );
}
